<template>
  <b-card>
    <div class="d-flex justify-content-between flex-wrap mb-1 ">
      <b-form
        class="d-flex align-items-center flex-sm-nowrap flex-wrap"
        @submit.prevent="onSearch"
      >
        <b-form-input v-model="search" />
        <b-button variant="primary" class="ml-sm-1 mt-sm-0 mt-50" type="submit">
          جستجو
        </b-button>
      </b-form>
    </div>
    <data-table :fields="fields" :items="exercises" :loading="loading">
      <template #id="{ data }">
        {{ data.item.id }}
      </template>

      <template #title="{ data }">{{ data.item.title }}</template>
      <!-- <template #available_at="{ data }">
        <b-badge variant="light-primary">
          {{ data.item.available_at ? calcDate(data.item.available_at) : "-" }}
        </b-badge></template
      > -->
      <template #detail="{ data }">
        <b-button
          size="sm"
          variant="flat-secondary"
          @click="data.toggleDetails"
        >
          <span class="ml-50">مشاهده جزییات</span>
        </b-button></template
      >

      <template #status="{ data }">
        <div style="white-space: nowrap">
          <b-badge
            class="mx-50"
            :variant="data.item.has_answer ? 'light-success' : 'light-danger'"
            >{{ data.item.has_answer ? "جواب داده شده" : "جواب نداده" }}
          </b-badge>
          <b-badge
            class="mx-50"
            v-if="
              !data.item.has_answer &&
              data.item.times.started_at &&
              data.item.times.deadline_at &&
              !deadlineAtTimer[data.item.id]
            "
            :variant="'light-success'"
            >فعال
          </b-badge>
          <span
            v-show="
              !data.item.has_answer &&
              data.item.times.started_at &&
              data.item.times.deadline_at &&
              deadlineAtTimer[data.item.id]
            "
            style="white-space: nowrap"
            class="mx-2"
            ><timer
              :time="data.item.times.deadline_at"
              :type="1"
              v-model="deadlineAtTimer[data.item.id]"
          /></span>

          <span>
            <b-badge
              v-if="
                !data.item.has_answer &&
                data.item.times.started_at &&
                data.item.times.deadline_at &&
                !deadlineAtTimer[data.item.id] 
              "
              class="mx-50"
              variant="light-danger"
              >جریمه
            </b-badge>
          </span>
        </div>
      </template>

      <template #row-details="{ data }">
        <div class="d-flex flex-wrap">
          <b-button
            v-for="(session, index) in data.item.sessions.sessions"
            :key="index"
            class="d-flex flex-column mr-2 p-50"
            variant="gradient-secondary"
            :to="{
              name: 'show-session-course',
              params: {
                id: session.pivot.course_id,
                session_id: session.pivot.session_id,
              },
            }"
          >
            <small class="mb-50">{{
              " دوره " + session.pivot.course_id
            }}</small>
            <small>{{ " جلسه " + session.pivot.session_id }}</small>
          </b-button>
        </div>
      </template>
    </data-table>
    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div
        class="col-md-6 ml-auto d-flex justify-content-md-center align-items-center"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="my-2 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BFormGroup,
  BPagination,
  BLink,
  BAvatar,
  BCard,
  BDropdownItem,
  BDropdown,
  BFormCheckbox,
  BForm,
  BFormInput,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import qs from "qs";
import Timer from "@core/components/timer/Timer.vue";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    VBModal,
    BBadge,
    BPagination,
    BCard,
    BFormGroup,
    BLink,
    BAvatar,
    BDropdownItem,
    BDropdown,
    BFormCheckbox,
    BForm,
    BFormInput,
    Timer,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      selectAll: false,
      removeExercisesData: [],
      exercises: [],
      loading: false,
      deadlineAtTimer: {},
      url: "",
      currentPage: 1,
      choosenPage: 1,
      pagination: {},
      visible: false,
      search: "",
      fields: [
        { key: "id", label: "شناسه" },
        { key: "title", label: "نام" },
        { key: "detail", label: "جزییات" },
        { key: "status", label: "وضعیت" },
      ],
    };
  },
  watch: {
    selectAll: {
      handler(val) {
        val
          ? (this.removeExercisesData = this.exercises.map(
              (semester) => semester.id
            ))
          : (this.removeExercisesData = []);
      },
      immediate: true,
    },
    removeExercisesData: {
      handler(val) {
        val.length == this.exercises.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
    search(val) {
      if (!val && this.$route.query.key) {
        this.$router.push({
          name: this.$route.params.id ? "user-exercises" : "profile-exercises",
        });
      }
    },
    $route: {
      handler(val) {
        this.getExercises();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router.push({
          name: this.$route.params.id ? "user-exercises" : "profile-exercises",
          query: {
            page: val,
          },
        });
      }
    },
  },
  async created() {
    this.url = `/panel/exercises?includes=sessions`;
    await this.getExercises();
  },
  methods: {
    goTo() {
      this.currentPage = this.choosenPage;
    },
    async onSearch() {
      if (this.search) {
        this.$router.push({
          name: this.$route.params.id ? "user-exercises" : "profile-exercises",
          query: {
            key: this.search,
          },
        });
      }
    },
    finalAmount(item) {
      let finalAmount = 0;
      if (item.percentage) {
        finalAmount =
          Number(item.amount) -
          (Number(item.amount) * Number(item.rebate)) / 100;
      } else {
        finalAmount = Number(item.amount) - Number(item.rebate);
      }

      return finalAmount > 0
        ? this.decodePersianName(String(parseInt(finalAmount)))
        : "0";
    },
    removeExercise(item) {
      this.$bvModal
        .msgBoxConfirm("آیا میخواهید این مورد حذف شود ؟", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "بله",
          cancelTitle: "خیر",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`/panel/exercises/${item.id}`);
              await this.$router.push({
                name: "exercises",
                query: { page: 1 },
              });
              this.currentPage = await this.$route.query.page;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "مورد با موفقیت حذف شد.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
              await this.getExercises();
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "مشکلی پیش آمده است",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    removeExercises() {
      if (this.removeExercisesData.length) {
        this.$bvModal
          .msgBoxConfirm("آیا میخواهید موارد انتخاب شده حذف شوند ؟", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "بله",
            cancelTitle: "خیر",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await new Promise((resolve, reject) => {
                  this.removeExercisesData.map(async (exercise, index) => {
                    await this.$http.delete(`/panel/exercises/${exercise}`);
                    if (index + 1 == this.removeExercisesData.length) {
                      resolve();
                    }
                  });
                });
                await this.$router.push({
                  name: "exercises",
                  query: { page: 1 },
                });
                this.currentPage = await this.$route.query.page;
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "مورد با موفقیت حذف شدند.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
                await this.getExercises();
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "مشکلی پیش آمده است",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "موردی انتخاب نشده است",
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    async getExercises() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        if (this.$route.params.id) {
          params.filters = {
            user_id: this.$route.params.id,
          };
        }
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.exercises = data.data.exercises;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
